var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 96,
    viewBox: "0 0 110 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.75 95.2521C73.9835 95.2521 95.25 73.9857 95.25 47.7521C95.25 21.5186 73.9835 0.252136 47.75 0.252136C21.5165 0.252136 0.25 21.5186 0.25 47.7521C0.25 73.9857 21.5165 95.2521 47.75 95.2521Z",
    fill: "url(#paint0_linear_36189_73404)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_36189_73404)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.604,
    y: 13.9307,
    width: 49.2959,
    height: 61.3656,
    rx: 6.33333,
    fill: "url(#paint1_linear_36189_73404)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.771 24.2818C34.5116 24.6554 33.0576 25.0272 31.6589 25.12C30.4633 25.1992 29.3085 25.0762 28.3633 24.5525C28.2301 24.4788 28.0632 24.5295 27.9911 24.6659C27.919 24.8023 27.9686 24.973 28.1019 25.0468C29.133 25.6179 30.3903 25.7672 31.6943 25.6807C33.1182 25.5863 34.5985 25.212 35.8831 24.8331C36.0322 25.142 36.3409 25.4301 36.8846 25.6426C37.7198 25.9691 38.86 25.965 40.0613 25.7811C41.8036 25.5144 43.6777 24.8784 44.8827 24.4264C44.9322 24.408 45.0057 24.3787 45.0958 24.34C45.1233 24.4021 45.154 24.4632 45.1881 24.5232C45.4836 25.0463 46.0064 25.4692 46.5392 25.6202C49.918 26.578 53.8614 25.4304 57.0722 24.4965C57.2172 24.4541 57.3018 24.2986 57.2611 24.1494C57.2194 24.0003 57.0678 23.9136 56.9217 23.956C53.801 24.8639 49.9696 26.0093 46.6853 25.0786C46.281 24.964 45.8878 24.639 45.6637 24.242C45.6385 24.1977 45.6165 24.1524 45.5956 24.1065C46.0383 23.882 46.559 23.5692 46.8391 23.2342C47.1268 22.8909 47.1982 22.5244 46.9478 22.1782C46.7325 21.8823 46.4063 21.8572 46.0668 22.0106C45.7011 22.1749 45.3243 22.559 45.2024 22.7393C44.9739 23.076 44.9014 23.4413 44.9431 23.7974C44.8355 23.8439 44.7481 23.8786 44.6941 23.8988C43.5155 24.3407 41.6836 24.9645 39.98 25.2253C38.8839 25.3932 37.8427 25.4156 37.0806 25.1177C36.7555 24.9906 36.5408 24.8423 36.4242 24.6701C36.6543 24.5998 36.876 24.5305 37.0879 24.4644C37.507 24.3337 38.3795 24.1174 39.0028 23.7318C39.4986 23.4252 39.8347 23.0081 39.8152 22.4853C39.8052 22.2167 39.6532 22.0374 39.4115 21.9369C39.0502 21.7869 38.4254 21.8595 38.1927 21.9101C37.4871 22.0632 36.5453 22.6968 36.0793 23.4108C35.8934 23.6957 35.7828 23.9938 35.771 24.2818ZM36.3506 24.1063C36.55 24.0449 36.7427 23.9847 36.9278 23.9269C37.3189 23.8048 38.1366 23.611 38.7187 23.2509C39.0269 23.0603 39.2786 22.8319 39.2664 22.5068C39.2654 22.4815 39.2409 22.4743 39.2192 22.4639C39.1857 22.4481 39.1474 22.4372 39.1065 22.4286C38.8301 22.3709 38.4587 22.4267 38.3067 22.4598C37.7146 22.5882 36.927 23.1238 36.5361 23.7229C36.4535 23.8494 36.3877 23.9784 36.3506 24.1063ZM45.4858 23.5387C45.7439 23.4028 46.0141 23.2385 46.2272 23.0597C46.3404 22.9647 46.4359 22.8671 46.4963 22.7657C46.5469 22.6819 46.5666 22.596 46.5062 22.513C46.4821 22.4794 46.4458 22.4788 46.4085 22.4851C46.3689 22.4918 46.3283 22.5062 46.2876 22.5247C46.0196 22.6454 45.7428 22.9274 45.6538 23.0597C45.5495 23.2131 45.4979 23.3754 45.4858 23.5387Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.958,
    y: 33.1063,
    width: 27.3125,
    height: 1.20635,
    rx: 0.603175,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.958,
    y: 40.1924,
    width: 27.3125,
    height: 1.20635,
    rx: 0.603175,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.958,
    y: 47.2786,
    width: 27.3125,
    height: 1.20635,
    rx: 0.603175,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.958,
    y: 54.3646,
    width: 27.3125,
    height: 1.20635,
    rx: 0.603175,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.958,
    y: 61.4508,
    width: 27.3125,
    height: 1.20635,
    rx: 0.603175,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.958,
    y: 68.5369,
    width: 27.3125,
    height: 1.20635,
    rx: 0.603175,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_36189_73404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.434 7.14911H78.6526C77.5444 7.14911 76.646 8.09456 76.646 9.26083V21.0247C76.646 22.1909 77.5444 23.1364 78.6526 23.1364H102.434C103.543 23.1364 104.441 22.1909 104.441 21.0247V9.26083C104.441 8.09456 103.543 7.14911 102.434 7.14911Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.5835 17.6688C83.8952 17.6688 84.9585 16.6055 84.9585 15.2938C84.9585 13.9821 83.8952 12.9188 82.5835 12.9188C81.2718 12.9188 80.2085 13.9821 80.2085 15.2938C80.2085 16.6055 81.2718 17.6688 82.5835 17.6688Z",
    fill: "#CAC8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.1255,
    y: 12.9188,
    width: 12.6667,
    height: 4.75,
    rx: 2.375,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6478 78.0584C66.7461 78.0584 71.4842 76.5162 75.4211 73.8729L91.5313 89.2516L97.3739 82.4728L81.8282 67.633C84.6993 63.5926 86.3874 58.6529 86.3874 53.3188C86.3874 39.6555 75.3111 28.5792 61.6478 28.5792C47.9845 28.5792 36.9082 39.6555 36.9082 53.3188C36.9082 66.9821 47.9845 78.0584 61.6478 78.0584ZM82.7492 53.3188C82.7492 64.8863 73.3719 74.2636 61.8044 74.2636C50.2369 74.2636 40.8596 64.8863 40.8596 53.3188C40.8596 41.7513 50.2369 32.374 61.8044 32.374C73.3719 32.374 82.7492 41.7513 82.7492 53.3188Z",
    fill: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_36189_73404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8024 74.6687C73.7168 74.6687 83.3753 65.0988 83.3753 53.2937C83.3753 41.4886 73.7168 31.9187 61.8024 31.9187C49.888 31.9187 40.2295 41.4886 40.2295 53.2937C40.2295 65.0988 49.888 74.6687 61.8024 74.6687Z",
    fill: "white",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.5303 89.2523L97.3729 82.4736L98.2529 83.3136C99.1067 84.1287 99.6179 85.2673 99.674 86.4791C99.7301 87.6908 99.3266 88.8763 98.5521 89.7749C97.7776 90.6735 96.6957 91.2115 95.5443 91.2705C94.3929 91.3296 93.2663 90.9049 92.4125 90.0898L91.5325 89.2497L91.5303 89.2523Z",
    fill: "#B6B6B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_36189_73404",
    x: 17.2707,
    y: 10.7641,
    width: 61.9626,
    height: 74.0322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.16667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.16667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36189_73404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36189_73404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_36189_73404",
    x: 75.8543,
    y: 4.77411,
    width: 34.1283,
    height: 22.3206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.375,
    dy: 0.791667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.879324 0 0 0 0 0.879324 0 0 0 0 0.879324 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36189_73404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36189_73404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_36189_73404",
    x: 37.0628,
    y: 28.752,
    width: 49.4793,
    height: 49.0833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_36189_73404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_36189_73404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36189_73404",
    x1: 47.3838,
    y1: -15.215,
    x2: 48.3569,
    y2: 151.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36189_73404",
    x1: 48.252,
    y1: 13.9307,
    x2: 48.252,
    y2: 75.2963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentEmpty);
export default __webpack_public_path__ + "static/media/comment-empty.1d8b930e1709208ecd25fabaa295acce.svg";
export { ForwardRef as ReactComponent };